import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

const FilterMenu = (props) => {
  const { filters, defaultAlignment = 'left' } = props;
  const intl = useIntl();
  const menu = useRef(null);
  const [direction, setDirection] = useState(defaultAlignment);

  useEffect(() => {
    if (!menu.current) return;
    const { left, right } = menu.current.getBoundingClientRect();
    if (right > window.innerWidth) {
      setDirection('right');
    } else if (left < 0) {
      setDirection('left');
    }
  }, []);

  return (
    <div ref={menu} style={{ [direction]: '0' }} className="filter-card">
      <div className="card-header">
        <h4 className="drs-card-header-title">{intl.formatMessage({ id: 'filters' })}</h4>
        <button className="close float-right" onClick={props.handleShowHide}>
          <span>&times;</span>
        </button>
      </div>
      <div className="card-body drs-body-padding">
        <div className="filter-card-body">
          {filters.map((filter, index) => {
            const FilterComponent = filter.component;
            return <FilterComponent key={index} {...filter.props} />;
          })}
        </div>
      </div>
      <div className="card-body drs-body-padding--footer"></div>
    </div>
  );
};

export default FilterMenu;
